import { createContext } from 'react';

export type ComparerContext = {
  showUnchanged: boolean;
  setShowUnchanged: (newValue: boolean) => void;
  expandAll: boolean | undefined;
  setExpandAll: (newValue: boolean) => void;
};

export const ComparerContext = createContext<ComparerContext>({
  showUnchanged: false,
  setShowUnchanged: () => {},
  expandAll: undefined,
  setExpandAll: () => {}
});
